import * as React from "react";
function TransportTaxiTypeExec() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 120 120"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#636566",
    fillRule: "nonzero",
    d: "M-51.67,-50.158C-56.789,-50.158 -60.94,-27.014 -60.939,1.536C-60.939,30.084 -56.789,53.229 -51.67,53.229C-46.551,53.228 -42.401,30.085 -42.401,1.535C-42.401,-27.014 -46.551,-50.158 -51.67,-50.158",
    opacity: 0.47,
    transform: "scale(1 -1) rotate(88.297 47.984 15.055)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "nonzero",
    d: "M-2.769,-15.993C-1.06,-14.284 1.728,-11.887 1.403,-9.115C1.077,-6.343 -1.169,-0.166 -2.769,0.438L-9.863,-2.171L-2.769,-15.993Z",
    transform: "scale(-1 1) rotate(-21.639 202.238 57.702)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "nonzero",
    d: "M-5.333,-20.487C-3.693,-18.713 -0.363,-11.866 -0.796,-9.109C-1.23,-6.35 -3.712,-0.265 -5.333,0.276L-11.847,-2.199L-5.333,-20.487Z",
    transform: "scale(-1 1) rotate(-23.855 169.758 159.454)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,10.286C0.301,10.948 2.105,13.895 4.271,14.557C6.436,15.218 10.165,14.857 11.609,13.955C13.052,13.053 14.315,12.331 15.278,9.865C16.24,7.399 17.624,1.805 14.315,-0.842C11.007,-3.488 2.887,-4.932 2.045,-3.969C1.203,-3.007 0,10.286 0,10.286",
    transform: "translate(93.706 72.762)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-18.737C-1.081,-18.117 -2.282,-17.596 -3.25,-15.729C-4.218,-13.863 -4.702,-10.44 -4.632,-8.885C-4.563,-7.329 -4.045,-4.252 -2.731,-2.178C-1.417,-0.104 -0.277,0.864 1.383,1.106C3.042,1.348 7.214,1 7.94,0.827C8.666,0.654 9.669,0.032 10.153,-0.556C10.637,-1.143 11.708,-2.319 12.296,-5.015C12.884,-7.712 13.025,-12.213 10.191,-17.226C8.717,-19.832 2.351,-20.085 0,-18.737",
    transform: "translate(59.696 88.304)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M-2.093,-2.076C-4.663,-2.098 -6.747,-1.178 -6.748,-0.021C-6.748,1.135 -4.664,2.09 -2.093,2.111C0.476,2.133 2.56,1.213 2.561,0.057C2.561,-1.1 0.476,-2.055 -2.093,-2.076",
    transform: "scale(1 -1) rotate(89.521 69.103 -8.057)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-16.3C-0.941,-15.761 -1.985,-15.308 -2.827,-13.684C-3.669,-12.059 -4.09,-9.082 -4.03,-7.729C-3.97,-6.375 -3.519,-3.699 -2.376,-1.894C-1.233,-0.09 -0.241,0.752 1.203,0.963C2.647,1.173 5.624,0.963 6.255,0.812C6.887,0.662 7.759,0.121 8.18,-0.391C8.601,-0.902 9.534,-1.924 10.045,-4.27C10.556,-6.616 10.887,-10.526 8.421,-14.887C7.139,-17.154 2.045,-17.473 0,-16.3",
    transform: "translate(13.587 84.43)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    fillRule: "nonzero",
    d: "M0,-3.012C0.888,-9.737 4.466,-9.164 7.638,-10.56C10.297,-11.73 13.375,-15.035 18.195,-16.986C28.092,-20.991 47.679,-19.642 60.32,-19.152C69.954,-18.779 82.793,-9.353 86.1,-6.119C86.1,-6.119 86.34,-6.154 88.882,-5.214C90.599,-4.58 93.959,-3.435 94.388,-3.396C94.817,-3.357 95.808,-3.396 97.659,-2.519C104.545,0.741 104.031,7.732 103.822,12.808C103.9,13.237 104.005,14.197 103.978,14.564C103.886,15.801 96.4,17.559 85.982,17.914C84.092,17.979 69.297,17.913 64.004,17.844C62.819,17.829 61.805,17.008 61.528,15.856C60.77,12.701 60.208,7.798 59.476,5.542C57.285,-1.208 48.308,0.595 47.629,8.161C47.193,13.025 47.816,15.02 48.377,16.953C40.387,16.546 22.563,15.207 14.208,14.209C13.595,14.136 12.441,13.432 12.207,12.262C11.185,7.415 13.172,0.61 7.309,-0.189C1.363,0.492 1.308,8.218 2.391,12.773C2.277,12.773 2.001,12.451 1.607,12.213C0.625,11.62 -0.04,10.179 -0.37,9.081C-0.809,7.617 -0.965,5.92 -0.913,4.496C-0.899,4.099 -0.839,3.703 -0.702,3.329C-0.077,1.622 -0.038,-2.146 0,-3.012",
    transform: "translate(7.878 67.99)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    d: "M0,5.064C-1.958,4.161 -0.983,3.079 -0.383,2.596C1.355,1.197 5.093,-1.905 10.767,-2.841C14.829,-3.511 20.127,-3.351 23.804,-0.426C27.785,2.74 31.198,7.477 31.668,8.317C29.899,8.575 5.029,7.383 0,5.064",
    transform: "translate(21.411 53.616)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillRule: "nonzero",
    d: "M0,-12.039C0,-12.039 4.963,-9.427 8.885,-5.742C11.629,-3.165 14.504,-0.725 14.871,-0.505C15.237,-0.285 23.433,0.09 27.176,0.014C34.138,-0.127 45.74,-0.623 44.966,-0.568C44.966,-0.568 40.822,-3.628 35.288,-6.996C30.318,-10.022 28.885,-10.517 24.928,-11.323C20.97,-12.129 0,-12.039 0,-12.039",
    transform: "translate(45.248 62.474)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    d: "M0,-7.327C-2.199,-7.775 -9.65,-7.946 -15.839,-8.01C-14.686,-7.167 -13.479,-6.204 -12.356,-5.149C-9.613,-2.572 -6.737,-0.132 -6.371,0.088C-6.004,0.308 2.191,0.683 5.934,0.607C8.761,0.55 12.347,0.434 15.565,0.321C14.08,-0.669 12.31,-1.814 10.361,-3.001C5.39,-6.026 3.957,-6.521 0,-7.327",
    transform: "translate(66.49 61.881)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M0,-6.798C1.053,-3.713 4.928,-0.929 5.43,-0.802C6.888,-0.432 11.228,0.054 13.499,-0.166C14.303,-0.244 16.654,-0.476 17.016,-0.838C15.133,-1.805 9.078,-4.752 3.005,-6.285C0.758,-6.852 0,-6.798 0,-6.798",
    transform: "translate(68.271 72.045)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M0,-5.272C0.572,-4.795 1.307,-4.532 2.039,-3.271C2.759,-2.028 2.761,-0.538 3.215,-0.248C3.668,0.043 5.261,-0.154 5.63,-0.278C6.413,-0.538 6.039,-1.253 6.039,-1.253C6.039,-1.253 5.337,-2.982 4.123,-3.82C3.353,-4.351 0.47,-5.315 0,-5.272",
    transform: "translate(102.61 71.406)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0,-4.488C1.866,-4.399 9,-4.303 13.649,-4.895C14.165,-4.961 14.842,-4.758 15.158,-4.344C15.309,-4.148 15.433,-3.902 15.475,-3.602C15.611,-2.642 15.883,-0.782 15.883,-0.782C15.883,-0.782 10.846,0.204 7.238,0.264C3.629,0.324 -1.662,0.473 -3.893,0.149C-3.725,-0.576 -3.463,-2.834 -3.17,-3.413C-2.588,-4.565 -1.322,-4.551 0,-4.488",
    transform: "translate(91.861 80.165)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M-1.68,-1.68C-4.031,-1.68 -5.937,-0.928 -5.937,0C-5.937,0.928 -4.031,1.68 -1.68,1.68C0.671,1.68 2.577,0.928 2.577,0C2.577,-0.928 0.671,-1.68 -1.68,-1.68",
    transform: "matrix(0 -1 -1 0 13.624 74.877)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4F4F4F",
    fillRule: "nonzero",
    d: "M0,-11.686C-0.43,-11.019 -0.845,-10.525 -2.106,-7.786C-4.202,-3.234 -4.246,-0.477 -4.246,-0.477L-0.722,0C-0.722,0 -0.235,-2.768 0.225,-4.297C0.684,-5.827 2.121,-10.01 3.497,-11.681L0,-11.686Z",
    transform: "translate(34.913 61.606)"
  }));
}
export default TransportTaxiTypeExec;